import { Card } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useFormikContext } from "formik";
import React from "react";

import FormField from "@/components/atoms/FormField";
import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { OrderFormData } from "@/components/screens/OrderFormPage/types";
import { OrderCommentsTabMessages } from "@/messages/order-form-page/order-comments-data-tab.messages";

type Props = {
  messages: OrderCommentsTabMessages;
};

export default function CommentsDataTab({ messages }: Props) {
  const { values, errors, handleChange } = useFormikContext<OrderFormData>();

  return (
    <MDBox mt={2}>
      <Grid container spacing={3}>
        <Grid size={12}>
          <MDBox height="100%">
            <Card sx={{ height: "100%" }}>
              <MDBox p={3}>
                <MDBox display="flex" justifyContent="space-between">
                  <MDTypography variant="h5" fontWeight="bold">
                    {messages.orderCommentTitle}
                  </MDTypography>
                </MDBox>

                <MDBox mt={2}>
                  <Grid container spacing={3}>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <FormField
                        externalLabel
                        variant="outlined"
                        rows={4}
                        disabled={values.disabledButton}
                        name="orderComments1"
                        label={messages.orderCom1Label}
                        value={values.orderComments1}
                        onChange={handleChange}
                        fullWidth
                        multiline
                        error={!!errors.orderComments1}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <FormField
                        externalLabel
                        variant="outlined"
                        rows={4}
                        disabled={values.disabledButton}
                        name="orderComments2"
                        label={messages.orderComments2Label}
                        value={values.orderComments2}
                        onChange={handleChange}
                        fullWidth
                        multiline
                        error={!!errors.orderComments2}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <FormField
                        externalLabel
                        variant="outlined"
                        rows={4}
                        disabled={values.disabledButton}
                        name="orderComments3"
                        label={messages.orderComments3Label}
                        value={values.orderComments3}
                        onChange={handleChange}
                        fullWidth
                        multiline
                        error={!!errors.orderComments3}
                      />
                    </Grid>
                  </Grid>
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
}
